import makeStyles from '@material-ui/core/styles/makeStyles';
import {v4 as uuidv4} from 'uuid';
import AddSponsor from './AddSponsor';
import Sponsor from './Sponsor';

type Props = {
  sponsorList: string[];
  disposeModal: () => void;
};

const useStyles = makeStyles(() => ({
  grid: {
    display: 'grid',
    paddingTop: '20px',
    rowGap: '20px',
    gridTemplateColumns: `repeat(3, 1fr)`,
  },
}));

const SponsorList = (props: Props) => {
  const classes = useStyles();
  const {sponsorList, disposeModal} = props;
  return (
    <>
      <div className={classes.grid}>
        {sponsorList.map((sponsor) => {
          return <Sponsor key={uuidv4()} url={sponsor} />;
        })}
        <AddSponsor disposeModal={disposeModal} />
      </div>
    </>
  );
};

export default SponsorList;
